import { render, staticRenderFns } from "./_main.vue?vue&type=template&id=45e091e4"
import script from "./_main.vue?vue&type=script&lang=js"
export * from "./_main.vue?vue&type=script&lang=js"
import style0 from "./_main.vue?vue&type=style&index=0&id=45e091e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports